export const PSINFO_UPDATE='psinfo/psform/PSINFO_UPDATE';
export const GET_PSINFO='psinfo/psform/GET_PSINFO';
export const SET_PSINFO='psinfo/psform/SET_PSINFO';